<div class="wrap wrapMain"></div>

<div class="wrap wrapFoot">
  <div class="cta">
    <button type="submit" class="btnSubmit" (click)="saveBene()">Submit</button>
    <button type="button" class="btnCancel" (click)="cancel()">Cancel</button>
  </div>
</div>
